import { create } from 'zustand';
import cookieInfo from '@alife/bc-cookie-info';
import MTop from '@/common/mtop';
import getLanguage from '@/common/local-language';

// 评价异步接口
const PRODUCT_REVIEW_VIEW = 'mtop.alibaba.icbu.screview.getaggregatescore';
const PRODUCT_STORE_VIEW = 'mtop.alibaba.icbu.screview.getAggregateScore';
const PRODUCT_REVIEW_LIST = 'mtop.alibaba.icbu.review.complete.productreview';
const PRODUCT_STORE_LIST = 'mtop.alibaba.icbu.review.new.shopreview';

type State = {
  review: {
    [key in ReviewType.TypeInfo]: Partial<ReviewType.Root & ReviewType.StoreList>;
  };
};

type Action = {
  fetchOverview: (params: {
    companyId: string | number;
    productId: string | number;
    type: ReviewType.TypeInfo;
  }) => void;
  fetchList: (params: {
    companyId: string;
    productId: string;
    type: ReviewType.TypeInfo;
    sellerAliId: string;
    currentPage?: number;
    clusterId?: number;
  }) => void;
};

const ReviewStore = create<State & Action>((set) => ({
  review: {
    product: {
      productReviewList: [],
    },
    company: {},
  },
  fetchOverview: async (params) => {
    const { productId, companyId, type } = params;
    const result: ReviewType.Root = await MTop(
      type === 'product' ? PRODUCT_REVIEW_VIEW : PRODUCT_STORE_VIEW,
      {
        relationType: type,
        reviewEntity: 'TAOrder',
        relationId: type === 'product' ? productId : companyId,
        companyId,
        language: getLanguage(),
        currency: cookieInfo.getBuyerCurrency(),
      },
    );
    if (!result.code) {
      set((state) => ({
        review: {
          ...state.review,
          [type as ReviewType.TypeInfo]: {
            ...state.review[type],
            ...result,
          },
        },
      }));
    }
  },
  fetchList: async (params) => {
    const { productId, companyId, type, sellerAliId, currentPage = 1, clusterId = 0 } = params;
    const result: ReviewType.Root = await MTop(
      type === 'product' ? PRODUCT_REVIEW_LIST : PRODUCT_STORE_LIST,
      {
        currentPage,
        clusterId,
        pageSize: 3,
        language: getLanguage(),
        currency: cookieInfo.getBuyerCurrency(),
        companyId,
        sellerAliId,
        productId,
      },
    );
    if (result.code && result.code !== '200') {
      // 无店铺评价
      if (type === 'company') {
        set({
          review: {
            product: {},
            company: {},
          },
        });
      }
    } else {
      set((state) => {
        return {
          review: {
            ...state.review,
            [type as ReviewType.TypeInfo]: {
              ...state.review[type],
              ...result,
              clusterId: params.clusterId || 0,
              currentPage: params.currentPage || 1,
            },
          },
        };
      });
    }
  },
}));

export default ReviewStore;
